import { CancelToken } from 'axios';
import { API_V1, API_V2 } from '../api';
import {
	EventV2,
	EventV2Result,
	EventManagementData,
} from '../EventsApi/EventModel';
import { UpsertEventRequest } from '../EventsApi/EventsApi';
import { parseEvents } from '../EventsApi/util';

export function getGroupEvents(groupId: string, cancelToken?: CancelToken): Promise<EventV2[]> {
	return API_V2.get(`/groups/${groupId}/events`, { cancelToken })
		.then(({ data }) => data as EventV2Result[])
		.then(parseEvents);
}

/**
 * Available to users with permission to manage events on this group
 */
export function createGroupEvent(groupId: string, payload: UpsertEventRequest): Promise<EventManagementData> {
	return API_V1.put(`/group/${groupId}/events/admin`, payload)
		.then(({ data }) => data as EventManagementData);
}

/**
 * Available to users with permission to manage events on this group
 * who are admins of this event
 */
export function getGroupAdminEvent(groupId: string, eventId: string): Promise<EventManagementData> {
	return API_V1.get(`/group/${groupId}/events/admin/${eventId}`)
		.then(({ data }) => data as EventManagementData);
}

/**
 * Available to users with permission to manage events on this group
 * who are admins of this event
 */
export function updateGroupEvent(groupId: string, eventId: string, payload: UpsertEventRequest): Promise<EventManagementData> {
	return API_V1.post(`/group/${groupId}/events/admin/${eventId}`, payload)
		.then(({ data }) => data as EventManagementData);
}
